<template>
    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-title color="primary">
                <span class="text-h6 text-white"
                    >{{ index + 1 }}. Vertreter -
                    {{ vertreter.vorname }} {{ vertreter.name }}
                </span>
                <template v-slot:actions>
                    <v-icon size="large" color="white">mdi-chevron-down</v-icon>
                </template>
            </v-expansion-panel-title>

            <v-expansion-panel-text class="mt-6">
                <v-row class="mt-6 mb-6">
                    <v-col cols="6">
                        <!--  Steckbrief -->
                        <v-card
                            class="border rounded-lg mx-10"
                            style="
                                border: 1px solid lightgray;
                                box-shadow: none;
                            "
                        >
                            <div style="display: flex; align-items: center">
                                <div>
                                    <v-icon size="40" color="primary" class="ml-6"
                                        >mdi-account-child</v-icon
                                    >
                                </div>
                                <div style="flex-grow: 1">
                                    <v-card-title
                                        class="pb-0"
                                        style="
                                            display: flex;
                                            justify-content: space-between;
                                        "
                                    >
                                        <span
                                            class="text-h6 font-weight-bold text-primary ml-5"
                                        >
                                            {{ vertreter.vorname }}
                                            {{ vertreter.name }}
                                            <Tooltip
                                                top
                                                v-if="
                                                    vertreter.geschlecht ===
                                                    'MAENNLICH'
                                                "
                                            >
                                                <Button size="medium" icon>
                                                    <v-icon color="primary"
                                                        >mdi-gender-male</v-icon
                                                    >
                                                    
                                                </Button>
                                                <template #content>
                                                    <span>männlich</span>
                                                </template>
                                            </Tooltip>
                                            <Tooltip
                                                top
                                                v-if="
                                                    vertreter.geschlecht ===
                                                    'WEIBLICH'
                                                "
                                            >
                                                <Button size="medium" icon>
                                                    <v-icon color="primary"
                                                        >mdi-gender-female</v-icon
                                                    ></Button
                                                >
                                                <template #content>
                                                    <span>weiblich</span>
                                                </template>
                                            </Tooltip>
                                            <Tooltip
                                                top
                                                v-if="
                                                    vertreter.geschlecht ===
                                                    'DIVERS'
                                                "
                                            >
                                                <Button size="medium" icon>
                                                    <v-icon color="primary"
                                                        >mdi-gender-transgender</v-icon
                                                    ></Button
                                                >
                                                <template #content>
                                                    <span>divers</span>
                                                </template>
                                            </Tooltip>
                                            <span
                                                class="text-subtitle-1"
                                                style="color: gray"
                                                v-if="
                                                    vertreter.geburtsname !==
                                                    null
                                                "
                                                >(geb.
                                                {{
                                                    vertreter.geburtsname
                                                }})</span
                                            >
                                        </span>
                                    </v-card-title>

                                    <v-card-text class="pt-0">
                                        <div
                                            class="text-subtitle-1"
                                            style="color: gray"
                                        >
                                            <div class="ml-5 py-0">
                                                {{ capitalizedVertreterArt }}
                                            </div>
                                        </div>
                                    </v-card-text>
                                </div>
                            </div>
                            <v-divider class="mx-4"></v-divider>

                            <v-card-text class="mx-12 text-subtitle-1">
                                <div class="d-xl-flex flex-column flex-xl-row">
                                    <div style="flex: 1">
                                        <div class="mb-2">
                                            <Tooltip top>
                                                <Button size="medium" icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        style="color: lightgray"
                                                        >mdi-cake</v-icon
                                                    >
                                                </Button>
                                                <template #content>
                                                    <span
                                                        >Geburtsdatum,
                                                        Geburtsort</span
                                                    >
                                                </template>
                                            </Tooltip>
                                            <span
                                                v-if="
                                                    vertreter.geburtsdatum &&
                                                    vertreter.geburtsdatum.trim() !==
                                                        ''
                                                "
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                            >
                                                {{
                                                    transformDate(vertreter.geburtsdatum)
                                                }}
                                                <span
                                                    v-if="
                                                        vertreter.geburtsort &&
                                                        vertreter.geburtsort.trim() !==
                                                            ''
                                                    "
                                                >
                                                    in
                                                    {{ vertreter.geburtsort }}
                                                </span>
                                            </span>
                                            <span
                                                v-else
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                                >-</span
                                            >
                                        </div>

                                        <div class="mb-2">
                                            <Tooltip top>
                                                <Button size="medium" icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        style="color: lightgray"
                                                        >mdi-earth</v-icon
                                                    >
                                                </Button>
                                                <template #content>
                                                    <span
                                                        >Staatsangehörigkeit</span
                                                    >
                                                </template>
                                            </Tooltip>
                                            <span
                                                v-if="
                                                    vertreter.staatsangehoerigkeit &&
                                                    vertreter.staatsangehoerigkeit.trim() !==
                                                        ''
                                                "
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                            >
                                                {{
                                                    vertreter.staatsangehoerigkeit
                                                }}
                                            </span>
                                            <span
                                                v-else
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                                >-</span
                                            >
                                        </div>

                                        <div class="mb-2">
                                            <Tooltip top>
                                                <Button size="medium" icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        style="color: lightgray"
                                                        >mdi-flag</v-icon
                                                    >
                                                </Button>
                                                <template #content>
                                                    <span>Herkunftsland</span>
                                                </template>
                                            </Tooltip>
                                            <span
                                                v-if="
                                                    vertreter.herkunftsland &&
                                                    vertreter.herkunftsland.trim() !==
                                                        ''
                                                "
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                            >
                                                {{ vertreter.herkunftsland }}
                                            </span>
                                            <span
                                                v-else
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                                >-</span
                                            >
                                        </div>

                                        <div class="mb-2">
                                            <Tooltip top>
                                                <Button size="medium" icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        style="color: lightgray"
                                                        >mdi-ring</v-icon
                                                    >
                                                </Button>
                                                <template #content>
                                                    <span>Familienstand</span>
                                                </template>
                                            </Tooltip>
                                            <span
                                                v-if="
                                                    vertreter.familienstand &&
                                                    vertreter.familienstand.trim() !==
                                                        ''
                                                "
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                            >
                                                {{
                                                    vertreter.familienstand.toLowerCase()
                                                }}
                                            </span>
                                            <span
                                                v-else
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                                >-</span
                                            >
                                        </div>
                                    </div>

                                    <!-- Hauptwohnsitz -->
                                    <div class="kontakt" style="flex: 1">
                                        <div
                                            v-if="vertreter.hauptwohnsitz"
                                            class="mb-2"
                                        >
                                            <Tooltip top>
                                                <Button size="medium" icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        style="color: lightgray"
                                                        >mdi-home</v-icon
                                                    >
                                                </Button>
                                                <template #content>
                                                    <span>Hauptwohnsitz</span>
                                                </template>
                                            </Tooltip>
                                            <span
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                            >
                                                {{
                                                    vertreter.hauptwohnsitz
                                                        .strasse
                                                }}
                                                {{
                                                    vertreter.hauptwohnsitz
                                                        .hausnummer
                                                }},
                                                {{
                                                    vertreter.hauptwohnsitz
                                                        .postleitzahl
                                                }}
                                                {{
                                                    vertreter.hauptwohnsitz.ort
                                                }}
                                                <span
                                                    v-if="
                                                        vertreter.hauptwohnsitz
                                                            .ortsteil
                                                    "
                                                >
                                                    ({{
                                                        vertreter.hauptwohnsitz
                                                            .ortsteil
                                                    }})
                                                </span>
                                            </span>
                                        </div>

                                        <!-- Kontaktnummern -->
                                        <div class="mb-2">
                                            <div
                                                style="
                                                    display: flex;
                                                    align-items: flex-start;
                                                "
                                            >
                                                <Tooltip top>
                                                    <Button size="medium" icon>
                                                        <v-icon
                                                            class="mr-2"
                                                            style="
                                                                color: lightgray;
                                                            "
                                                            >mdi-phone</v-icon
                                                        >
                                                    </Button>
                                                    <template #content>
                                                        <span
                                                            >Kontaktnummern</span
                                                        >
                                                    </template>
                                                </Tooltip>
                                                <div
                                                    v-if="
                                                        vertreter.kontaktnummern !==
                                                            null &&
                                                        vertreter.kontaktnummern
                                                            .length > 0
                                                    "
                                                    style="
                                                        color: black;
                                                        font-weight: 500;
                                                    "
                                                >
                                                    <div
                                                        v-for="nummer in vertreter.kontaktnummern"
                                                        :key="
                                                            nummer.kontaktnummernArt
                                                        "
                                                        style="
                                                            margin-bottom: 5px;
                                                        "
                                                    >
                                                        {{ toCamelCase(nummer.kontaktnummernArt) }}: {{ nummer.nummer }}
                                                    </div>
                                                </div>

                                                <div
                                                    v-else
                                                    style="color: black"
                                                    class="ml-1"
                                                >
                                                    -
                                                </div>
                                            </div>
                                        </div>

                                        <!-- E-Mail -->
                                        <div>
                                            <Tooltip top>
                                                <Button size="medium" icon>
                                                    <v-icon
                                                        class="mr-2"
                                                        style="color: lightgray"
                                                        >mdi-email</v-icon
                                                    >
                                                </Button>
                                                <template #content>
                                                    <span>E-Mail</span>
                                                </template>
                                            </Tooltip>
                                            <span
                                                v-if="vertreter.email"
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                                >{{ vertreter.email }}</span
                                            ><span
                                                v-else
                                                style="
                                                    color: black;
                                                    font-weight: 500;
                                                "
                                                >-</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>

                            <v-card-text
                                v-if="
                                    (vertreter.bemerkungen !== null &&
                                        vertreter.bemerkungen.length > 0) ||
                                    vertreter.neuerHauptwohnsitz ||
                                    vertreter.umzugsdatum !== null
                                "
                                class="mx-12 text-subtitle-1"
                                style="color: gray"
                            >
                                <div
                                    class="mb-2"
                                    v-if="
                                        vertreter.bemerkungen !== null &&
                                        vertreter.bemerkungen.length > 0
                                    "
                                >
                                    <span size="medium" icon>
                                        <v-icon color="primary"> mdi-information </v-icon>
                                    </span>

                                    <span class="ml-2"
                                        >Bemerkung vorhanden:
                                        {{ vertreter.bemerkungen }}</span
                                    >
                                </div>

                                <div
                                    class="mb-2"
                                    v-if="
                                        vertreter.neuerHauptwohnsitz !== null ||
                                        vertreter.umzugsdatum !== null
                                    "
                                >
                                    <div style="display: flex">
                                        <span size="medium" icon>
                                            <v-icon color="primary"
                                                >mdi-information</v-icon
                                            >
                                        </span>

                                        <div>
                                            <div
                                                v-if="
                                                    vertreter.neuerHauptwohnsitz
                                                "
                                                class="ml-2"
                                            >
                                                <b>Neuer Hauptwohnsitz:</b>
                                                <div>
                                                {{
                                                    vertreter.neuerHauptwohnsitz
                                                        .strasse
                                                }}
                                                {{
                                                    vertreter.neuerHauptwohnsitz
                                                        .hausnummer
                                                }},
                                                {{
                                                    vertreter.neuerHauptwohnsitz
                                                        .postleitzahl
                                                }}
                                                {{
                                                    vertreter.neuerHauptwohnsitz
                                                        .ort
                                                }}
                                                </div>
                                                <span
                                                    v-if="
                                                        vertreter
                                                            .neuerHauptwohnsitz
                                                            .ortsteil
                                                    "
                                                >
                                                    ({{
                                                        vertreter
                                                            .neuerHauptwohnsitz
                                                            .ortsteil
                                                    }})
                                                </span>
                                            </div>
                                            <div
                                                v-if="
                                                    vertreter.umzugsdatum !==
                                                    null
                                                "
                                                class="ml-2"
                                            >
                                                <b>Umzugsdatum:</b>
                                                {{
                                                    transformDate(vertreter.umzugsdatum)
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <!--  Zusatzinfos -->
                    <v-col cols="6" class="pr-6">
                        <v-card
                            style="width: 100%; border: none; box-shadow: none"
                        >
                            <v-card-text class="pt-0">
                                <div class="d-flex mb-2">
                                    <div
                                        class="text-subtitle-1 font-weight-bold text-grey-darken-2"
                                        style="flex: 1"
                                    >
                                        Sorgeberechtigung
                                    </div>
                                </div>
                                    <div class="d-flex mb-2 even-row">
                                        <div
                                            class="text-subtitle-1 text-grey-darken-2 text-grey-darken-2"
                                            style="flex: 1"
                                        >
                                            Alleinerziehend
                                        </div>
                                        <div
                                            class="text-subtitle-1 font-weight-bold"
                                            style="flex: 1; margin-left: 10px"
                                        >
                                            <template
                                                v-if="vertreter.alleinerziehend"
                                            >
                                                <span>ja</span>
                                            </template>
                                            <template
                                                v-else-if="
                                                    vertreter.alleinerziehend ==
                                                    false
                                                "
                                            >
                                                <span>nein</span>
                                            </template>
                                            <template v-else>
                                                <span>-</span>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="d-flex mb-2">
                                        <div
                                            class="text-subtitle-1 text-grey-darken-2"
                                            style="flex: 1"
                                        >
                                            Allein sorgeberechtigt
                                        </div>
                                        <div
                                            class="text-subtitle-1 font-weight-bold"
                                            style="flex: 1; margin-left: 10px"
                                        >
                                            <template
                                                v-if="
                                                    vertreter.personSorgeberechtigt
                                                "
                                            >
                                                <span>ja</span>
                                            </template>
                                            <template
                                                v-else-if="
                                                    vertreter.personSorgeberechtigt ==
                                                    false
                                                "
                                            >
                                                <span>nein</span>
                                            </template>
                                            <template v-else>
                                                <span>-</span>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="d-flex mb-2 even-row">
                                        <div
                                            class="text-subtitle-1 text-grey-darken-2"
                                            style="flex: 1"
                                        >
                                            Negativbescheid vorliegend
                                        </div>
                                        <div
                                            class="text-subtitle-1 font-weight-bold"
                                            style="flex: 1; margin-left: 10px"
                                        >
                                            <template
                                                v-if="
                                                    vertreter.negativbescheidLiegtVor
                                                "
                                            >
                                                <span>ja</span>
                                            </template>
                                            <template
                                                v-if="
                                                    vertreter.negativbescheidLiegtVor ==
                                                    false
                                                "
                                            >
                                                <span>nein</span>
                                            </template>
                                            <template v-else>
                                                <span>-</span>
                                            </template>
                                        </div>
                                    </div>
                                <div class="d-flex mb-2 mt-4">
                                    <div
                                        class="text-subtitle-1 font-weight-bold text-grey-darken-2"
                                        style="flex: 1"
                                    >
                                        Berufliche Informationen
                                    </div>
                                </div>
                                    <div class="d-flex mb-2 even-row">
                                        <div
                                            class="text-subtitle-1 text-grey-darken-2"
                                            style="flex: 1"
                                        >
                                            Berufstätig
                                        </div>
                                        <div
                                            class="text-subtitle-1 font-weight-bold"
                                            style="flex: 1; margin-left: 10px"
                                        >
                                            <template
                                                v-if="vertreter.berufstaetig == 'JA'"
                                                >ja</template
                                            >

                                            <template
                                                v-else-if="
                                                    vertreter.berufstaetig ==
                                                    'NEIN'
                                                "
                                            >
                                                nein
                                            </template>
                                            <template v-else>keine Angabe</template>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex mb-2">
                                        <div
                                            class="text-subtitle-1 text-grey-darken-2"
                                            style="flex: 1"
                                        >
                                            Arbeitgeber
                                        </div>
                                        <div
                                            class="text-subtitle-1 font-weight-bold"
                                            style="flex: 1; margin-left: 10px"
                                        >
                                            <template
                                                v-if="
                                                    vertreter.arbeitgeber !==
                                                    null
                                                "
                                                >{{
                                                    vertreter.arbeitgeber
                                                }}</template
                                            >
                                            <template v-else
                                                ><span>-</span>
                                            </template>
                                        </div>
                                    </div>

                                    <div class="d-flex mb-2 even-row">
                                        <div
                                            class="text-subtitle-1 text-grey-darken-2"
                                            style="flex: 1"
                                        >
                                            Elternzeit
                                        </div>
                                        <div
                                            class="text-subtitle-1 font-weight-bold"
                                            style="flex: 1; margin-left: 10px"
                                        >
                                            <template
                                                v-if="vertreter.elternzeit !== null"
                                                > Von
                                                {{
                                                    transformDate(vertreter.elternzeit.von)
                                                }}

                                                <span
                                                    v-if="
                                                        vertreter.elternzeit.bis
                                                    "
                                                >
                                                    bis
                                                    {{
                                                        transformDate(vertreter.elternzeit.bis)
                                                    }}
                                                    </span>
                                            </template
                                            >
                                            <template v-else>-</template>
                                        </div>
                                    </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import Tooltip from '@s/views/general_components/components/Tooltip';
import { transformDate } from '@s/util/helper.js';

export default {
    name: 'vertreter',
    components: {
        Tooltip,
    },
    computed: {
        capitalizedVertreterArt() {
            if (!this.vertreter.vertreterArt) return '';
            const lowerCaseValue = this.vertreter.vertreterArt.toLowerCase();
            return (
                lowerCaseValue.charAt(0).toUpperCase() + lowerCaseValue.slice(1)
            );
        },
    },
    methods: {
        transformDate,
        toCamelCase(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        },
    },
    props: {
        vertreter: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            default: null,
        },
    },
};
</script>

<style lang="stylus" scoped>
i
  font-weight: bold


.even-row
  background-color: #f0f0f0

.flex-container {
  display: flex;
  flex-wrap: wrap;
}
</style>
